import { callAuthorizedGraphQLEndpoint } from '../../../../../../Module/graphQL'

const getReferralPrograms = async ({ cityId }) => {
  const query = `  query ($cityId: ID!) {
    referralPrograms(id: $cityId){
      isActive
      nodes {
        id
        requiredMissions
        bonusAmount
        cityId
        createdAt
        archivedAt
        userFriendlyBatchId
        signUps
        completedMissionsAmount
        amountSpent
        currencySign
        signUpsLimit
      }
    }
  }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    cityId,
  })
}

const createReferralCampaign = async input => {
  const query = `mutation ($input: CreateReferralProgramInput) {
    createReferralProgram(input: $input){
      isActive
      nodes {
        id
        requiredMissions
        bonusAmount
        cityId
        createdAt
        archivedAt
        userFriendlyBatchId
        signUps
        completedMissionsAmount
        amountSpent
        currencySign
      }
    }
  }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const disableReferralCampaign = async input => {
  const query = `mutation ($input: DisableReferralProgramInput) {
    disableReferralProgram(input: $input){
      isActive
      nodes {
        id
        requiredMissions
        bonusAmount
        cityId
        createdAt
        archivedAt
        userFriendlyBatchId
        signUps
        completedMissionsAmount
        amountSpent
        currencySign
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

export { getReferralPrograms, disableReferralCampaign, createReferralCampaign }
